import { nanoid } from "nanoid";

export default {
  data: {
    prompts: [
      {
        id: nanoid(),
        prompt: "What was the best thing that happened today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What was the worst thing that happened today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What was the most interesting thing I saw or heard today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What was the most challenging thing I faced today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What am I grateful for today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What was the most fun thing I did today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What did I learn today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What was the most surprising thing that happened today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "My life is beautiful because...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Someone or something that makes me happy is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What did I do today that I am proud of?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "A problem or a challenge I am currently facing is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "My end goal with the main problem I am currently facing is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Some potential solutions to the problem or challenge I am currently facing is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Some pros and cons of my potential solution to the problem/challenge I am currently facing is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Can I collaborate with anyone else to solve a problem/challenge I am currently facing? If yes, how?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Something I love the most about my body is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Some beliefs or messages about my body that I need to let go of in order to cultivate more self-love and acceptance are...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Some activities or practices that help me feel connected to and in tune with my body are...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Something I should remind myself especially when I’m feeling self-critical or negative that can uplift my mood instantly is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "How can I use social media to cultivate a more positive influence in shaping my body image?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Some ways I can prioritize my physical health and well-being, without falling into the trap of diet culture or body shaming are...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What does creativity mean to me?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "What is one thing that I have always wanted to create, and what steps can I take to make it a reality?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What is something I am passionate about?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Am I doing something I am passionate about daily?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "What are some ways I can take time for myself and recharge my batteries to cultivate creativity and inspiration?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Write a story(however long you want) from the perspective of an inanimate object that has come to life.",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Write about a childhood memory that has stayed with you.",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Write about a character who wakes up one day with a superpower.",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Write a story that begins with the sentence “The door creaked open, revealing a long-forgotten room.”",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Write about a relationship that taught you an important lesson about yourself or the world around you.",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Write about a place that has had a significant impact on your life, and what memories or emotions it brings up for you.",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Write a poem that explores the idea of home and what it means to you.",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "How does my body feel today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Something I am nervous or anxious about today is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "My top priorities for today are...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Five of my top priorities for this week are...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Something I can do to make today amazing is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "Something I did today that brought me joy and fullfilment is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What was a moment of joy, delight, or contentment today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Something I could have done differently today is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "How can I make tomorrow even better?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "A decision I need to make is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "What was the most memorable dream I had recently? Write down as many details as you can remember.",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "What recurring themes or symbols appear in my dreams? Are there any patterns I can identify?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "What emotions did I feel in my dream last night, and do they relate to any current issues in my waking life?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "If I could have any dream I wanted tonight, it would be about...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "If I could ask a dream character any question, who would I choose, and what would I ask them?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "One of the most bizarre or surreal dream I’ve ever had is...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Three things that went well today are... because...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Did I show gratitude towards anyone today?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Something I did to take care of myself today was...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "Some unexpected events that took place today were...",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What am I looking forward to tomorrow?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt:
          "What was the most significant event of my day and why was it important?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What is something silly that always makes me laugh?",
        isUserGenerated: false,
      },
      {
        id: nanoid(),
        prompt: "What is a favorite childhood memory that still brings me joy?",
        isUserGenerated: false,
      },
    ],
  },
};
